<div [class.isVisible]="showLoader$ | async" class="loader">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<div class="content">
    <ng-content></ng-content>
</div>
